import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import SideBar from "../Components/Sidebar";
import {
  Button,
  Menu,
  MenuItem,
  Chip,
  Tooltip,
  TextField,
  Pagination,
} from "@mui/material";
import { getShows } from "../Services/ShowsApi";
import Loader from "../Components/Loader";
import ProfileUpdate from "./ProfileUpdate";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import SortIcon from "@mui/icons-material/Sort"; // Import the SortIcon
import { getUserProfileDetails, updateShowDetails } from "../Services/ShowsApi";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import Snackbar from "@mui/material/Snackbar";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import PageHeader from "./Container/PageHeader/Pageheader";
import { setShow } from "../redux/notificationSlice";
import { useDispatch, useSelector } from "react-redux";
import useClickOutside from "../Hook/useClickOutside";
import Schedules from "./Schedules";
import MissedSchedules from "./MissedSchedules";

import Lottie from "lottie-react";
import animationData from "../Assests/daiLogoAnimation.json";
import ToggleTypeSelector from "../Components/ToggleTypeSelector";
import ChatModal from "./ChatModal";

const Shows = () => {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState({});
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1); // Track current page
  const [limit] = useState(8); // Set limit per page
  const [totalCount, setTotalCount] = useState(0); // Track total count of shows
  const [sortOrder, setSortOrder] = useState({
    field: "CreatedDttm",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState("");

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]); // Extract Base64 string
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  // const handleEditImage = async (e, show) => {
  //     const file = e.target.files[0];

  //     try {
  //         // Convert file to Base64
  //         const base64String = await readFileAsBase64(file);

  //         // Construct payload
  //         const payload = {
  //             UserID: show.UserID,
  //             ShowName: show.ShowName,
  //             RoomID: show.RoomID,
  //             thumbnailBase64: base64String
  //         };

  //         console.log('Payload:', payload);
  //         await updateShowDetails(payload);
  //         setSnackBarMessage("Image uploaded successfully!");
  //         const response = await getShows(searchQuery, page, limit);
  //         setShows(response?.data?.Data);
  //         setTotalCount(response?.data?.totalCount);

  //     } catch (error) {
  //         console.error('Error processing the file:', error);
  //     }
  // };

  // Fetch shows from API with pagination
  useEffect(() => {
    const fetchShows = async () => {
      setLoading(true); // Set loading state
      try {
        const response = await getShows(searchQuery, page, limit); // Pass page and limit to the API
        console.log("getshows response: ", response);
        setShows(response?.data?.Data);
        setTotalCount(response?.data?.totalCount); // Set total count from API response
        const profileStatus = await getUserProfileDetails("UserID");
        if (
          profileStatus?.data?.body?.Data?.length > 0 &&
          profileStatus.data.body.Data[0]?.isNameEmpty === 1
        ) {
          setOpenModal(true);
        } else {
          setOpenModal(false);
        }
      } catch (error) {
        console.error("Error fetching shows:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchShows();
  }, [page, limit, searchQuery]); // Trigger the API call when page, limit, or searchQuery changes

  // Handle sorting change (by date or name)
  const handleSortChange = (field, direction) => {
    setSortOrder({ field, direction });
    handleClose(); // Close the menu after selection
  };

  // Handle the search input change
  const handleSearchChange = async (event) => {
    setSearchQuery(event.target.value); // Update search query
    setPage(1); // Reset to first page when search query changes
  };


  // Filter and sort shows based on search query and sort order
  const filteredShows =
    shows && shows
      ? shows.sort((a, b) => {
        if (sortOrder.field === "CreatedDttm") {
          const dateA = new Date(a.CreatedDttm);
          const dateB = new Date(b.CreatedDttm);
          return sortOrder.direction === "asc"
            ? dateA - dateB
            : dateB - dateA;
        } else if (sortOrder.field === "ShowName") {
          const nameA = a.ShowName.toLowerCase();
          const nameB = b.ShowName.toLowerCase();
          return sortOrder.direction === "asc"
            ? nameA.localeCompare(nameB)
            : nameB.localeCompare(nameA);
        }
        return 0;
      })
      : [];

  // Handle the page change in pagination
  const handleChange = (event, value) => {
    setPage(value); // Change the page when pagination item is clicked
  };

  // Calculate total pages based on totalCount and limit
  const totalPages = Math.ceil(totalCount / limit);

  const dispatch = useDispatch();
  const info = useSelector((state) => state.info);

  const [toggleType, setToggleType] = useState("Upcoming Podcasts");
  const handleSearchTypeChange = (type) => {
    setToggleType(type);
  };

  const TYPE_Items = [
    { id: 0, type: "Upcoming Podcasts" },
    { id: 1, type: "Recorded Shows" },
    { id: 2, type: "Missed Schedules" },
  ];

  const renderContent = () => {
    switch (toggleType) {
      case "Upcoming Podcasts": // Upcoming Podcasts
        return <Schedules />;
      case "Recorded Shows":
        return (
          <div
            className="container-fluid"
            style={{ color: "#fff" }}
          >
            <div className="row">
              {/* <div className="col-6 my-4">
                    <h2>Shows</h2>
                </div> */}
              <div
                className="col-6 mb-2 d-flex justify-content-end"
                style={{
                  marginLeft: "auto",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {/* Search Bar */}
                <TextField
                  label="Search Shows"
                  variant="filled"
                  size="small"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  style={{ marginRight: "2vw", width: "40%" }}
                  InputProps={{ 
                    style: { 
                      color: "white",
                      fontSize: "2.0vh",
                      height: "5vh"
                    } 
                  }}
                  InputLabelProps={{ 
                    style: { 
                      color: "white",
                      fontSize: "1.6vh",
                    } 
                  }}
                  sx={{ 
                    bgcolor: "rgba(255, 255, 255, 0.1)", 
                    borderRadius: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(1.2vw, 1.3vh) scale(1)",
                    },
                    "& .MuiInputLabel-root.MuiInputLabel-shrink": {
                      transform: "translate(1.2vw, 0.6vh) scale(0.75)",
                    }
                  }}
                />

                <Button
                  id="sort-button"
                  aria-controls={open ? "sort-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  variant="outlined"
                  sx={{
                    bgcolor: "rgba(255, 255, 255, 0.1)",
                    border: "none",
                    minWidth: "5vh",
                    height: "5vh",
                    padding: "1vh",
                  }}
                >
                  <FilterAltIcon style={{ color: "white", fontSize: "2.5vh" }} />
                </Button>

                <Menu
                  id="sort-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "sort-button",
                  }}
                  sx={{
                    "& .MuiPaper-root": {
                      bgcolor: "rgba(25, 25, 62, 0.95)",
                    },
                    "& .MuiMenuItem-root": {
                      fontSize: "1.6vh",
                      padding: "1.2vh 2vw",
                      color: "white",
                    },
                    "& .MuiMenuItem-root:hover": {
                      bgcolor: "rgba(255, 255, 255, 0.1)",
                    }
                  }}
                >
                  <MenuItem
                    onClick={() => handleSortChange("CreatedDttm", "desc")}
                  >
                    <ArrowDownwardIcon style={{ marginRight: "1vw", fontSize: "2vh" }} /> Date
                    (Descending)
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleSortChange("CreatedDttm", "asc")}
                  >
                    <ArrowUpwardIcon style={{ marginRight: "1vw", fontSize: "2vh" }} /> Date
                    (Ascending)
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleSortChange("ShowName", "desc")}
                  >
                    <ArrowDownwardIcon style={{ marginRight: "1vw", fontSize: "2vh" }} /> Name
                    (Descending)
                  </MenuItem>
                  <MenuItem onClick={() => handleSortChange("ShowName", "asc")}>
                    <ArrowUpwardIcon style={{ marginRight: "1vw", fontSize: "2vh" }} /> Name
                    (Ascending)
                  </MenuItem>
                </Menu>
              </div>
            </div>

            {loading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '65vh' }}>
                <Loader message="Fetching shows" />
              </div>
            ) : (
              <div
                className="row"
                style={{height: "65vh",overflowY: "auto"}}
              >
                {filteredShows.length === 0 && (
                  <div className="podacast-empty-container">
                    <h4>No Shows Found</h4>
                  </div>
                )}
                {filteredShows.map((show, index) => (
                  <div
                    key={index}
                    className="col-md-3 d-flex justify-content-center mb-1"
                    style={{
                      padding: '0.8vh',
                    }}
                  >
                    <div
                      className="position-relative pointer"
                      style={{
                        width: "100%",
                        // maxWidth: "300px";
                        padding: '1.6vh',  
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1.6vh',
                        height: "fit-content",
                        borderRadius: '1.6vh',
                        border: '1px solid rgba(175, 175, 175, 0.5)',
                        background: 'rgba(255, 255, 255, 0.08)'
                      }}
                      onClick={() => navigate(`/shows/details/${show.ShowID}`)}
                    >
                      {/* Display loader until image is loaded */}
                          {!imageLoaded[index] && show.ThumbnailURL?.includes('ai-generated-content') && (
                        <div className="image-loader-overlay">
                          {/* <Loader /> */}
                          <div style={{
                            width: "100%",
                            height: "20vh",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'stretch',
                            borderRadius: '0.8vh',
                            background: 'rgba(0, 0, 0, 0.50)'
                          }}>
                            <div
                              style={{
                                width: "8vh",
                                height: "7.5vh",
                              }}
                            >
                              <Lottie animationData={animationData} loop={true} />
                            </div>
                          </div>
                        </div>
                      )}

                      {
                        show.ThumbnailURL?.includes('ai-generated-content') ?
                          (
                            <img
                              src={show.ThumbnailURL}
                              alt={show.ShowName}
                              style={{
                                width: "100%",
                                height: "20vh",
                                borderRadius: "0.8vh",
                                objectFit: "cover",
                                display: imageLoaded[index] ? "block" : "none",
                              }}
                              onLoad={() =>
                                setImageLoaded((prev) => ({
                                  ...prev,
                                  [index]: true,
                                }))
                              }
                            />
                          ) : (
                            <div style={{
                              width: "100%",
                              height: "20vh",
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              alignSelf: 'stretch',
                              borderRadius: '0.8vh',
                              background: 'rgba(0, 0, 0, 0.50)'
                            }}>
                              <div
                                style={{
                                  width: "8vh",
                                  height: "7.5vh",
                                }}
                              >
                                <Lottie animationData={animationData} loop={true} />
                              </div>
                            </div>
                          )
                      }

                      <Chip
                        style={{
                          position: "absolute",
                          bottom: "20%",
                          height: "auto",
                          right: "10px",
                          background: "#633B48",
                          color: "#fff",
                          borderRadius: "20px",
                          fontSize: "0.7em",
                        }}
                        label={show.RunTime}
                      />

                      <div
                        style={{
                          width: "100%",
                          color: "#fff",
                          // padding: "6px 12px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          // borderRadius: "0 0 8px 8px",
                        }}
                      >
                      <Tooltip 
                        title={show.ShowName} 
                        arrow 
                        placement="top"
                        sx={{
                          '& .MuiTooltip-tooltip': {
                            fontSize: '1.4vh',
                            padding: '0.8vh 1.2vw',
                            backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            borderRadius: '0.6vh',
                            letterSpacing: '0.056vh'
                          },
                          '& .MuiTooltip-arrow': {
                            color: 'rgba(0, 0, 0, 0.8)'
                          }
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "100",
                            fontSize: '2.0vh',
                            letterSpacing: '0.156vh'
                          }}
                          className="ellipsis"
                        >
                          {show.ShowName}
                        </span>
                      </Tooltip>
                        <span
                          style={{
                            fontWeight: "100",
                            fontSize: '1.4vh',
                            letterSpacing: '0.024vh'
                          }}>
                          {new Date(show.CreatedDttm).toLocaleDateString()}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )
            }
            
            {!loading && (
              <div
                className="d-flex justify-content-center"
                style={{marginTop: "0.8vh"}}
              >
                <Pagination
                  count={totalPages} // Use totalPages calculated from totalCount and limit
                  page={page}
                  onChange={handleChange}
                  sx={{
                    "& .MuiPaginationItem-root": {
                      fontSize: "1.6vh",
                      minWidth: "3.2vh",
                      height: "3.2vh",
                      margin: "0 0.4vh",
                      borderRadius: "50%",
                    },
                    "& .MuiPaginationItem-root svg": {
                      fontSize: "2vh",
                    },
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "rgb(38 88 215)",
                    },
                    "& .MuiPaginationItem-root:hover": {
                      backgroundColor: "rgb(100, 100, 100)", // Hover background color
                    },
                  }}
                />
              </div>
            )} 

            <ProfileUpdate open={openModal} onClose={handleCloseModal} />
          </div >
        );
      case "Missed Schedules": // Missed Schedules
        return <MissedSchedules />;
      default:
        return null;
    }
  };

  const value = useSelector((state) => state?.value);

  return (
    <>
      <div className="theme-bg clr-white height-100" style={{ display: "flex", overflow: 'hidden' }}>
        <SideBar />
        <div className="Page-main-container" >
          <PageHeader pageTitle="My Shows" />
          <div className="Page-sub-container">
            <ToggleTypeSelector
              TYPE_Items={TYPE_Items}
              handleSearchTypeChange={handleSearchTypeChange}
              toggleType={toggleType}
            />
            {renderContent()}
          </div>
        </div>
        <Snackbar
          open={!!snackBarMessage}
          autoHideDuration={5000}
          onClose={() => setSnackBarMessage("")}
          message="Image uploaded successfully!"
          style={{ backgroundColor: "white", color: "black" }}
        />
      </div>
      <ChatModal open={value?.isChatOpen} />
    </>
  );
};

export default Shows;
